import script from "./PrayerAdminDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayerAdminDisplay.vue?vue&type=script&setup=true&lang=js"

import "./PrayerAdminDisplay.vue?vue&type=style&index=0&id=592b01da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592b01da"]])

export default __exports__